export const version = process.env.VUE_APP_VERSION
export const source = 4 // 请求来源：1-安卓；2-IOS；3-微信；4-web；5-wxmp；6-h5
export const isProd = process.env.NODE_ENV === 'production'
export const isOnline = ['hm.ctsfreight.com'].includes(location.hostname)
export const amapkey = isOnline ? 'df7a4b68e62f3543876d6f769184d31b' : 'cb32d3a2065cfada82bee7f2a4e8c9cc'
export const amapStyle = isOnline ? 'amap://styles/dcedd202825797816b475861c923c35e' : 'amap://styles/d783f703fba83fde5d3ccd7621d6583b'
export const assets = 'https://static.jcex.cn/kjhaoyun' // 在线静态资源路径

// 根据域名设置接口地址
export let api = '/api/'
export let wsServe = 'wss://ws-im.jcex.cn'
export let iframeUrl = 'https://chat.jcex.cn/'
const envname = process.env.VUE_APP_ENV || location.hostname.split('.')[0]
switch (envname) {
  case '192': // 内网访问
  case 'localhost': // 本地环境
  case 'dev': // 开发环境
  case 'test': // 测试环境
    wsServe = 'wss://test-ws-im.kjhaoyun.com'
    iframeUrl = 'https://test-chat.kjhaoyun.com/'
    break
}

// 兼容旧导出方式
export default {
  version,
  isProd,
  isOnline,
  online: isOnline,
  amapkey,
  amapStyle,
  assets,
  api,
  wsServe,
  iframeUrl,
  cookieExpires: 1, // token 在 cookie 中存储的天数，默认1天
}
